// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, {FC, useMemo, useState} from "react";

// eslint-disable-next-line node/no-missing-import
// import type * as CSS from "csstype";

type componentProps = {
  userStyle?:string // React.CSSProperties | CSS.Properties
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

// const {rz, $} = window;

const UserStyle:FC<componentProps> = ({...props}) => {
  // const [theme, setTheme] = useState($("html").attr("data-theme"));

  const strStyle = useMemo<string>(() => (props.userStyle || ""), [props.userStyle]);

  // eslint-disable-next-line react/prop-types
  return (<style key={props?.key || props?.id || "user-style"}>{strStyle}</style>);
};

export default UserStyle;
